<input id="FileUploader" type="file" (change)="uploadPhoto($event)" style="display:none">
